import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let setStoreValue = function(state, item, value) {
	state[item] = value;
	localStorage.setItem(item, value);
}

let getStoreValue = function(state, item) {
	if(state[item] == null) {
		return localStorage.getItem(item);
	} else {
		return state[item];
	}
}

let getStoreValueBoolean = function(state, item) {
	let val = getStoreValue(state, item);
	return val === 'true' || val === true;
}

export const store = new Vuex.Store({
	state: {
		companyId: null,
		companyName: null,
		companyActive: null,
		fullname: null,
		photo: null,
		demoMode: null,
		loginInfo: null,
		propertyLists: null,
		admin: null,
		adminCompanyId: null,
		email: null,
		proPortalsPerProperty: null,
		subscriptions: null,
	},
	getters: {
		companyId: state => { return getStoreValue(state, 'companyId');},
		companyName: state => { return getStoreValue(state, 'companyName');},
		companyActive: state => { return getStoreValueBoolean(state, 'companyActive');},
		fullname: state => { return getStoreValue(state, 'fullname');},
		photo: state => { return getStoreValue(state, 'photo');},
		demoMode: state => { return getStoreValueBoolean(state, 'demoMode');},
		loginInfo: state => { return JSON.parse(getStoreValue(state, 'loginInfo'));},
		propertyLists: state => { return state.propertyLists;},
		admin: state => { return getStoreValueBoolean(state, 'admin');},
		adminCompanyId: state => { return getStoreValue(state, 'adminCompanyId');},
		email: state => { return getStoreValue(state, 'email');},
		proPortalsPerProperty: state => { return getStoreValueBoolean(state, 'proPortalsPerProperty');},
		subscriptions: state => { return JSON.parse(getStoreValue(state, 'subscriptions'));},
	},
	mutations: {
		clearAll(state) {
			Object.keys(state).map(key => {
				state[key] = null;
			});
			localStorage.clear();
		},
		setCompanyId(state, id) {
			setStoreValue(state, 'companyId', id);
		},
		setCompanyName(state, name) {
			setStoreValue(state, 'companyName', name);
		},
		setCompanyActive(state, active) {
			setStoreValue(state, 'companyActive', active);
		},
		setFullname(state, fullname) {
			setStoreValue(state, 'fullname', fullname);
		},
		setPhoto(state, photo) {
			setStoreValue(state, 'photo', photo);
		},
		setDemoMode(state, demoMode) {
			setStoreValue(state, 'demoMode', demoMode);
		},
		setLoginInfo(state, loginInfo) {
			setStoreValue(state, 'loginInfo', JSON.stringify(loginInfo));
		},
		setEmail(state, email) {
			setStoreValue(state, 'email', email);
		},
		setPropertyLists(state, propertyLists) {
			state.propertyLists = propertyLists;
		},
		setAdmin(state, admin) {
			setStoreValue(state, 'admin', admin);
		},
		setAdminCompanyId(state, id) {
			setStoreValue(state, 'adminCompanyId', id);
		},
		setProPortalsPerProperty(state, proPortalsPerProperty) {
			setStoreValue(state, 'proPortalsPerProperty', proPortalsPerProperty);
		},
		setSubscriptions(state, subscriptions) {
			setStoreValue(state, 'subscriptions', JSON.stringify(subscriptions));
		},
	}
})



// WEBPACK FOOTER //
// ./src/store.js